/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Footer_WorkspaceInputs */

const en_gc_footer_workspace = /** @type {(inputs: Gc_Footer_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

const zh_gc_footer_workspace = /** @type {(inputs: Gc_Footer_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作区`)
};

/**
* | output |
* | --- |
* | "Workspace" |
*
* @param {Gc_Footer_WorkspaceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_footer_workspace = /** @type {((inputs?: Gc_Footer_WorkspaceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Footer_WorkspaceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_footer_workspace(inputs)
	return zh_gc_footer_workspace(inputs)
});
export { gc_footer_workspace as "gc.footer.workspace" }